module.exports = __webpack_public_path__ + "static/img/tel_appli.3eda873.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tel_appli.png
// module id = /AeF
// module chunks = 1